package org.gstechnovos.jexonplastech.sections.product_details.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.dom.ref
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.gstechnovos.jexonplastech.util.animateSlideUp
import org.gstechnovos.jexonplastech.util.rememberScrollVisibility
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul

@Composable
fun ProductFeaturesSection(features: List<String>) {
    val palette = ColorMode.current.toSitePalette()
    val (isVisible, visibilityRef) = rememberScrollVisibility(threshold = 0.1)

    Div(
        attrs = Modifier
            .fillMaxWidth()
            .display(DisplayStyle.Flex)
            .flexDirection(FlexDirection.Column)
            .alignItems(com.varabyte.kobweb.compose.css.AlignItems.Center)
            .toAttrs {
                ref { element ->
                    visibilityRef(element)
                    onDispose {}
                }
            }
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .maxWidth(1200.px)
                .padding(leftRight = 5.percent, topBottom = 20.px)
                .animateSlideUp(isVisible, delayMs = 150)
        ) {
            SpanText(
                text = "Features & Use Cases",
                modifier = Modifier
                    .fontSize(24.px)
                    .fontWeight(FontWeight.Bold)
                    .color(palette.custom.darkText)
                    .margin(bottom = 20.px)
            )

            // Animated feature list with interactive hover states
            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = com.varabyte.kobweb.compose.foundation.layout.Arrangement.spacedBy(12.px)
            ) {
                features.forEach { feature ->
                    var isItemHovered by remember { mutableStateOf(false) }

                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .backgroundColor(palette.custom.lightGray.toRgb().copyf(alpha = 0.2f))
                            .padding(leftRight = 20.px, topBottom = 14.px)
                            .borderRadius(8.px)
                            .translateX(if (isItemHovered) 6.px else 0.px)
                            .transition(Transition.of(TransitionProperty.All, duration = 200.ms))
                            .onMouseEnter { isItemHovered = true }
                            .onMouseLeave { isItemHovered = false },
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        // Custom Checkmark/Bullet Icon
                        Box(
                            modifier = Modifier
                                .size(24.px)
                                .borderRadius(50.percent)
                                .backgroundColor(palette.brand.primaryBlue)
                                .margin(right = 16.px),
                            contentAlignment = Alignment.Center
                        ) {
                            SpanText(
                                text = "✓",
                                modifier = Modifier
                                    .color(palette.custom.white)
                                    .fontSize(12.px)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }

                        SpanText(
                            text = feature,
                            modifier = Modifier
                                .fontSize(16.px)
                                .lineHeight(1.5)
                                .color(palette.custom.darkText)
                        )
                    }
                }
            }
        }
    }
}